// export const BASE_URL = "https://backend-n3ap.onrender.com/api/v1/";
// export const BASE_URL = "https://backend.ineedbuddy.com/api/v1/";
export const BASE_URL = "https://ineedbuddy.com/api/v1/";
